import { render } from "./SelectSearch.vue?vue&type=template&id=39f80c50&scoped=true"
import script from "./SelectSearch.vue?vue&type=script&lang=js"
export * from "./SelectSearch.vue?vue&type=script&lang=js"

import "./SelectSearch.vue?vue&type=style&index=0&id=39f80c50&lang=scss&scoped=true"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f80c50"]])

export default __exports__